module.exports = __webpack_public_path__ + "static/media/anatomia.19bd3c81.png";